module.exports = __webpack_public_path__ + "static/placeholder-2ea33fb4c64b69a800e940b5735bb559.jpg";